import React, { Component } from 'react';
import { ContainerProps } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div style={{ width: "100%" }}>
        <NavMenu show={this.props.show} />

        <div style={{ width: "100%" }}>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js